module.exports = __webpack_public_path__ + "21913d789a3d4b70ce0a72e2ceeea239.svg";